import { css } from "@compiled/react";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

import { token } from "@atlaskit/tokens";

import { AgileVideo } from "@/components/agile-video/agile-video";
import { RichTextComponent } from "@/templates/agile-hub/src/sections/components/body-text";
import { TopicIntroduction } from "@/templates/agile-hub/types";

type Nullable<T> = T | null;

export interface UniformTopicIntroductionContentProps {
    topicIntroduction: Nullable<TopicIntroduction>;
}

function getRichText(richText: string | Document) {
    if (typeof richText === "string") {
        return richText;
    }

    return documentToHtmlString(richText);
}

// eslint-disable-next-line complexity
export const TopicIntroductionContent = ({
    topicIntroduction
}: UniformTopicIntroductionContentProps) => {
    return (
        <div
            data-testid="agile-hub-introduction-content"
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: token("space.250")
            })}
        >
            {topicIntroduction?.title && (
                <h2
                    css={css({
                        marginBlockEnd: token("space.0")
                    })}
                >
                    {topicIntroduction?.title}
                </h2>
            )}

            {topicIntroduction?.details && (
                <div
                    css={css({
                        marginBlockEnd: token("space.250")
                    })}
                >
                    <RichTextComponent
                        name={topicIntroduction?.title ?? ""}
                        text={getRichText(topicIntroduction?.details ?? "")}
                    />
                </div>
            )}

            {topicIntroduction?.embedLink && (
                <AgileVideo
                    embedLink={topicIntroduction?.embedLink ?? ""}
                    title={topicIntroduction?.title ?? ""}
                    thumbnail={topicIntroduction?.asset?.[0] ?? null}
                />
            )}
        </div>
    );
};
